function Spinner(spinner, checkmark) {
	this.spinner = spinner;
	this.checkmark = checkmark;
	this.animationFinished = false;
	this.requestFinished = false;
	
	//show spinner and hide checkmark element
	this.spinner.show();
	this.checkmark.hide();
	
	//start timeout
	setTimeout(this._minimumTime.bind(this), 350);
}

Spinner.prototype._minimumTime = function() {
	this.animationFinished = true;
	
	if(this.requestFinished) {
		this._finished();
	}
}

Spinner.prototype._finished = function() {
	this.spinner.hide();
	this.checkmark.show();
}

Spinner.prototype.done = function() {
	this.requestFinished = true;
	
	if(this.animationFinished) {
		this._finished();
	}
};
define("spinner", function(){});

